// Cấp bậc "Nhà Vật lí" theo level (backend /students/gamification trả `level`).
// Dùng để hiển thị danh hiệu trong modal qua ải / hạ trùm và hồ sơ học sinh.

export interface Rank {
  level: number
  name: string
  icon: string
  color: string   // màu điểm nhấn (hex)
}

// min = level tối thiểu để đạt bậc. Tra bậc cao nhất mà level thoả mãn.
const RANKS: Array<Omit<Rank, 'level'> & { min: number }> = [
  { min: 1, name: 'Tân binh Vật lí', icon: '🔰', color: '#64748b' },
  { min: 2, name: 'Nhà khám phá', icon: '🧭', color: '#0ea5e9' },
  { min: 3, name: 'Nhà thí nghiệm', icon: '🔬', color: '#14b8a6' },
  { min: 4, name: 'Nhà thám hiểm', icon: '🚀', color: '#6366f1' },
  { min: 5, name: 'Học giả', icon: '⚛️', color: '#8b5cf6' },
  { min: 7, name: 'Chuyên gia', icon: '🧠', color: '#f59e0b' },
  { min: 9, name: 'Bậc thầy Vật lí', icon: '👑', color: '#e11d48' },
  { min: 12, name: 'Huyền thoại', icon: '🌌', color: '#7c3aed' },
]

export function rankForLevel(level: number): Rank {
  let r = RANKS[0]
  for (const x of RANKS) if (level >= x.min) r = x
  return { level: Math.max(1, level || 1), name: r.name, icon: r.icon, color: r.color }
}
